
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { FormTextbox, FormPhotoUploader, FormDateBox } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { GENDERS } from '../../../shared/constants';

export const PermissiongroupNewForm = ({ initData, onDataChanged, clubData, traininggroupData }) => {
  const [newPermissiongroupData, setNewPermissiongroupData] = useState({ ...initData });

  useEffect(() => {
 
    setNewPermissiongroupData({ ...initData });
  }, [initData]);

  const updateField = (field) => (value) => {
    const newData = { ...newPermissiongroupData, ...{ [field]: value } };

    onDataChanged(newData);
    setNewPermissiongroupData(newData);
  };

  return (
    <Form
      className='plain-styled-form'
      screenByWidth={getSizeQualifier}
    >
    

      <GroupItem>
        <ColCountByScreen xs={1} sm={1} md={1} lg={1} />
        <FormItem>
          <FormTextbox
            label='Name'
            value={newPermissiongroupData.permissiongroupname}
            isEditing={false}
            onValueChange={updateField('permissiongroupname')}
          />
        </FormItem>
        
      </GroupItem>


    </Form>
  );
};
